// extracted by mini-css-extract-plugin
export default {"daniel":"daniel_daniel__IonQb","imageAndBlurb":"daniel_imageAndBlurb__hjdab","imageAndButton":"daniel_imageAndButton__nknXe","description":"daniel_description__Klfym"};